export { default as PhoneField, getPhoneFieldLabel } from './PhoneField';
export type { PhoneFieldData, PhoneFieldProps } from './PhoneField';
